import { CardProps } from '..'
import { Card, CardContent, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import EditIcon from "@mui/icons-material/Edit";
import { useState } from 'react';
import DialogEditarFazenda from './DialogEditarFazenda';
import { ICooperadoFazendaDetalhe } from '../../../../../../../types/api/cadastros/detalhar-cooperado';

export default function CardFazendas({
    data
}: PropsCardFazendas) {

    const [openEditar, setOpenEditar] = useState<ICooperadoFazendaDetalhe | null>(null);

    return (
        <Card>
            <CardContent>
                <Typography variant="h6" mb={2}>
                    Fazendas
                </Typography>
                <TableContainer>
                    <Table size="small" aria-label="tabela simples">
                        <TableHead>
                            <TableRow>
                                <TableCell><b>Nome</b></TableCell>
                                <TableCell><b>Inscrição</b></TableCell>
                                <TableCell align='right'></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.fazendas.map((row, index) => (
                                <TableRow
                                    key={index}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                        {row.nome}
                                    </TableCell>
                                    <TableCell>
                                        {row.inscricao}
                                    </TableCell>
                                    <TableCell align='right'>
                                        <IconButton
                                            aria-label="editar"
                                            onClick={() => setOpenEditar(row)}
                                            title="Editar"
                                        >
                                            <EditIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>

            {
                Boolean(openEditar) && openEditar &&
                    <DialogEditarFazenda
                        open={Boolean(openEditar)}
                        onClose={() => setOpenEditar(null)}
                        data={openEditar}
                    />
            }
        </Card>
    )
}


interface PropsCardFazendas extends CardProps {
}
